import { Button } from "@mantine/core";
import { IconFilePlus } from "@tabler/icons-react";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { FileUploader } from "react-drag-drop-files";
import { getSupportedFiles } from "../../../../../../../functions/utilFunctions";
import { notifications } from "@mantine/notifications";

const AddNoteAttachments = ({ files, setFiles }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <FileUploader
      handleChange={(f) => setFiles((prev) => [...prev, f])}
      types={getSupportedFiles()}
      maxSize={10}
      onSizeError={() =>
        notifications.show({
          message: lang.errors.main.file_size_is_exceeded,
          color: "red",
        })
      }
      classes="file-uploader"
    >
      <Button
        leftSection={<IconFilePlus size={18} />}
        size="md"
        variant="light"
        disabled={files.length > 9}
      >
        {lang.contact_lists.import.step_file.attachments}
      </Button>
    </FileUploader>
  );
};

export default AddNoteAttachments;
